import { ReactNode } from "react";
import { Link as WaspRouterLink, routes } from "wasp/client/router";
import { BeamButton as BaseBeamButton } from "../../client/components/ui/beam-button";

interface BeamButtonProps {
  children: ReactNode;
  size?: "default" | "sm" | "lg";
  className?: string;
  showArrow?: boolean;
  fullWidth?: boolean;
  /** When provided, renders a plain button instead of a signup link */
  onClick?: () => void;
}

export function BeamButton({
  children,
  size = "lg",
  className = "",
  showArrow = false,
  fullWidth = false,
  onClick,
}: BeamButtonProps) {
  if (onClick) {
    return (
      <BaseBeamButton
        size={size}
        className={className}
        showArrow={showArrow}
        fullWidth={fullWidth}
        onClick={onClick}
      >
        {children}
      </BaseBeamButton>
    );
  }

  return (
    <WaspRouterLink
      to={routes.SignupRoute.to}
      className={fullWidth ? "w-full" : "w-full sm:w-auto"}
    >
      <BaseBeamButton
        size={size}
        className={className}
        showArrow={showArrow}
        fullWidth={fullWidth}
      >
        {children}
      </BaseBeamButton>
    </WaspRouterLink>
  );
}
